export default __webpack_public_path__ + "static/media/ic-copy.bbd7b903.svg";